"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = GiveBeforeOther;
const react_1 = __importDefault(require("react"));
const thank_you_form_1 = __importStar(require("./thank-you-form"));
const use_give_links_1 = __importDefault(require("./use-give-links"));
const common_elements_1 = __importDefault(require("./common-elements"));
function GiveBeforeOther({ link, close, data, track, variant, onDownload, id }) {
    const { showThankYou, onThankYouClick } = (0, thank_you_form_1.useOnThankYouClick)();
    const [controlLink] = (0, use_give_links_1.default)();
    const beforeOpen = react_1.default.useCallback((e) => {
        close();
        if (onDownload) {
            onDownload(e);
        }
    }, [close, onDownload]);
    if (showThankYou) {
        return (react_1.default.createElement(thank_you_form_1.default, { link: link, close: close, source: variant, itemType: lookupVariant(variant), track: track, id: id }));
    }
    return (react_1.default.createElement("div", { className: 'give-before-pdf', "data-analytics-view": true, "data-analytics-nudge": 'donate', "data-nudge-placement": variant },
        react_1.default.createElement(common_elements_1.default, { data: data, onThankYouClick: onThankYouClick, giveLink: controlLink }),
        react_1.default.createElement("a", Object.assign({ href: link, onClick: beforeOpen, className: 'btn go-to' }, (track ? { 'data-track': track } : {}), { "data-variant": lookupVariant(variant) }),
            "Go to your ",
            lookupVariant(variant))));
}
function lookupVariant(variant) {
    if (variant === 'View online') {
        return 'book';
    }
    if (variant === null || variant === void 0 ? void 0 : variant.includes('resource')) {
        return 'resource';
    }
    return 'item';
}
